// @flow strict

import styled from 'styled-components';

import { LegacyTheme } from 'components/_ReactUI_V1';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    padding: 0px 24px 0px 24px;
`;

export const Body = styled.div`
    display: flex;
    flex-direction: column;

    padding: 24px;

    border-bottom: 1px solid ${LegacyTheme.defaultBuildingBlockBackground};
`;

export const Footer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;

    padding: 16px 24px 0px;
    margin-bottom: -4px;

    button + button {
        margin-left: 16px;
    }
`;

export const Field = styled.div`
    display: flex;
    flex-direction: column;

    & + & {
        margin-top: 31px;
    }
`;

export const Label = styled.label`
    font-size: 12px;
    line-height: 14px;
    color: ${LegacyTheme.defaultColor};
    margin-bottom: 8px;
`;

export const RadioStyles = {
    labelFontSize: '14px',
    labelColor: LegacyTheme.defaultColor,
    labelMinWidth: '50px',
};

export const RadioSuffixWrapper = styled.div`
    margin-left: 19px;
    margin-top: 5px;
`;

export const ImageStyle = {
    width: '310px',
};

export const BypassLabel = styled.div`
    font-size: 11px;
    line-height: 16px;
    color: ${LegacyTheme.defaultSubtleColor7B};
`;
